// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1G6uY","selected":"styles_selected__2dJIy"};